import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";

export const systemStatus: FieldSchema = {
  name: "systemStatus",
  grid: {
    displayed: true,
    order: 56,
  },
  data: {
    variant: DataVariants.ENUM,
    options: [
      {
        label: "Ready to use",
        value: "In service",
      },
      {
        label: "Out of service",
        value: "Out of service",
      },
      {
        label: "Decommissioned",
        value: "Decommissioned",
      },
      {
        label: "Disposed",
        value: "Disposed",
      },
    ],
  },
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: { label: "Equipment status", type: InputTypes.SELECT },
};
